// 지역 데이터
export const regions = {
  '서울': ['강남구', '강동구', '강북구', '강서구', '관악구', '광진구', '구로구', '금천구', '노원구', '도봉구', '동대문구', '동작구', '마포구', '서대문구', '서초구', '성동구', '성북구', '송파구', '양천구', '영등포구', '용산구', '은평구', '종로구', '중구', '중랑구'],
  '부산': ['강서구', '금정구', '기장군', '남구', '동구', '동래구', '부산진구', '북구', '사상구', '사하구', '서구', '수영구', '연제구', '영도구', '중구', '해운대구'],
  '대구': ['남구', '달서구', '달성군', '동구', '북구', '서구', '수성구', '중구'],
  '인천': ['강화군', '계양구', '남동구', '동구', '미추홀구', '부평구', '서구', '연수구', '옹진군', '중구'],
  '광주': ['광산구', '남구', '동구', '북구', '서구'],
  '대전': ['대덕구', '동구', '서구', '유성구', '중구'],
  '울산': ['남구', '동구', '북구', '울주군', '중구'],
  '세종': ['세종시'],
  '강원': ['강릉시', '고성군', '동해시', '삼척시', '속초시', '양구군', '양양군', '영월군', '원주시', '인제군', '정선군', '철원군', '춘천시', '태백시', '평창군', '홍천군', '화천군', '횡성군'],
  '경남': ['거제시', '거창군', '고성군', '김해시', '남해군', '밀양시', '사천시', '산청군', '양산시', '의령군', '진주시', '창녕군', '창원시', '통영시', '하동군', '함안군', '함양군', '합천군'],
  '경북': ['경산시', '경주시', '고령군', '구미시', '군위군', '김천시', '문경시', '봉화군', '상주시', '성주군', '안동시', '영덕군', '영양군', '영주시', '영천시', '예천군', '울릉군', '울진군', '의성군', '청도군', '청송군', '칠곡군', '포항시'],
  '전남': ['강진군', '고흥군', '곡성군', '광양시', '구례군', '나주시', '담양군', '목포시', '무안군', '보성군', '순천시', '신안군', '여수시', '영광군', '영암군', '완도군', '장성군', '장흥군', '진도군', '함평군', '해남군', '화순군'],
  '전북': ['고창군', '군산시', '김제시', '남원시', '무주군', '부안군', '순창군', '완주군', '익산시', '임실군', '장수군', '전주시', '정읍시', '진안군'],
  '제주': ['서귀포시', '제주시'],
  '충남': ['계룡시', '공주시', '금산군', '논산시', '당진시', '보령시', '부여군', '서산시', '서천군', '아산시', '예산군', '천안시', '청양군', '태안군', '홍성군'],
  '충북': ['괴산군', '단양군', '보은군', '영동군', '옥천군', '음성군', '제천시', '진천군', '청주시', '충주시'],
  '경기남부': ['과천시', '광명시', '광주시', '군포시', '김포시', '부천시', '성남시', '수원시', '시흥시', '안산시', '안성시', '안양시', '여주시', '오산시', '용인시', '의왕시', '이천시', '평택시', '하남시', '화성시'],
  '경기북부': ['가평군', '고양시', '구리시', '남양주시', '동두천시', '양주시', '양평군', '연천군', '의정부시', '파주시', '포천시']
};

// 매장 데이터
export const stores = [
  {
    id: 'songpa-olympic',
    name: '송파올림픽',
    region: '서울',
    city: '송파구',
    address: '서울 송파구 양재대로 1222 올림픽프라자상가 1층 88호',
    phone: '0507-1357-7860',
    hours: '일 12:00-18:00 / 월~토 10:00-19:00',
    lat: 37.515372,
    lng: 127.132014,
    images: {
      main: '/images/stores/songpa-olympic/main.jpg',
      exterior: '/images/stores/songpa-olympic/exterior.jpg',
      interior: '/images/stores/songpa-olympic/interior.jpg'
    }
  },
  {
    id: 'apgujeong',
    name: '압구정',
    region: '서울',
    city: '강남구',
    address: '서울 강남구 압구정로 228 내제1층 103호',
    phone: '0507-1468-9937',
    hours: '일 12:00-18:00 / 월~금 10:00-19:00 / 토 12:00-18:00',
    lat: 37.528692,
    lng: 127.032796,
    images: {
      main: '/images/stores/apgujeong/main.jpg',
      exterior: '/images/stores/apgujeong/exterior.jpg',
      interior: '/images/stores/apgujeong/interior.jpg'
    }
  },
  {
    id: 'gajwa',
    name: '가좌점',
    region: '인천',
    city: '서구',
    address: '인천 서구 원적로 99 1층 108호',
    phone: '0507-1373-6454',
    hours: '일~토 10:00-20:00 (일 12:00~20:00)',
    lat: 37.495359,
    lng: 126.682406,
    images: {
      main: '/images/stores/gajwa/main.jpg',
      exterior: '/images/stores/gajwa/exterior.jpg',
      interior: '/images/stores/gajwa/interior.jpg'
    }
  },
  {
    id: 'geomdan',
    name: '검단점',
    region: '인천',
    city: '서구',
    address: '인천 서구 완정로 154 에이동 101호',
    phone: '0507-1490-9886',
    hours: '일~토 10:00-18:00 (일 12:00~17:00)',
    lat: 37.601627,
    lng: 126.659313,
    images: {
      main: '/images/stores/geomdan/main.jpg',
      exterior: '/images/stores/geomdan/exterior.jpg',
      interior: '/images/stores/geomdan/interior.jpg'
    }
  },
  {
    id: 'godeok-intl',
    name: '고덕국제점',
    region: '경기남부',
    city: '평택시',
    address: '경기 평택시 고덕국제대로 94 우성고덕타워 2차 108호',
    phone: '0507-1360-6647',
    hours: '일 12:00-18:00 / 월~토 10:00-19:00',
    lat: 37.047595,
    lng: 127.044208,
    images: {
      main: '/images/stores/godeok-intl/main.jpg',
      exterior: '/images/stores/godeok-intl/exterior.jpg',
      interior: '/images/stores/godeok-intl/interior.jpg'
    }
  },
  {
    id: 'gwanggyo',
    name: '광교점',
    region: '경기남부',
    city: '수원시',
    address: '경기 수원시 영통구 도청로66번길 6 상가동 1층 113호',
    phone: '0507-1463-7228',
    hours: '일 11:00-18:00 / 월~금 10:00-19:00 / 토 11:00-18:00',
    lat: 37.289262,
    lng: 127.051768,
    images: {
      main: '/images/stores/gwanggyo/main.jpg',
      exterior: '/images/stores/gwanggyo/exterior.jpg',
      interior: '/images/stores/gwanggyo/interior.jpg'
    }
  },
  {
    id: 'daechi',
    name: '대치점',
    region: '서울',
    city: '강남구',
    address: '서울 강남구 남부순환로 2933',
    phone: '0507-1402-3588',
    hours: '일 12:00-18:00 / 월~금 10:00-19:00 / 토 12:00-18:00',
    lat: 37.493902,
    lng: 127.061046,
    images: {
      main: '/images/stores/daechi/main.jpg',
      exterior: '/images/stores/daechi/exterior.jpg',
      interior: '/images/stores/daechi/interior.jpg'
    }
  },
  {
    id: 'dangsan',
    name: '당산점',
    region: '서울',
    city: '영등포구',
    address: '서울 영등포구 양평로 11 105호',
    phone: '0507-1460-1467',
    hours: '일 정기휴무 / 월~금 10:30-19:00 / 토 11:30-17:30',
    lat: 37.532201,
    lng: 126.904736,
    images: {
      main: '/images/stores/dangsan/main.jpg',
      exterior: '/images/stores/dangsan/exterior.jpg',
      interior: '/images/stores/dangsan/interior.jpg'
    }
  },
  {
    id: 'luwon-city',
    name: '루원시티점',
    region: '인천',
    city: '서구',
    address: '인천 서구 가정로 437',
    phone: '032-294-9494',
    hours: '일 11:00-18:00 / 월~금 10:00-19:00 / 토 11:00-18:00',
    lat: 37.504934,
    lng: 126.671798,
    images: {
      main: '/images/stores/luwon-city/main.jpg',
      exterior: '/images/stores/luwon-city/exterior.jpg',
      interior: '/images/stores/luwon-city/interior.jpg'
    }
  },
  {
    id: 'munjeong',
    name: '문정점',
    region: '서울',
    city: '송파구',
    address: '서울 송파구 송파대로 167 B동 1층 141호',
    phone: '0507-1483-2392',
    hours: '일 정기휴무 / 월~금 10:00-19:00 / 토 11:00-17:00',
    lat: 37.484123,
    lng: 127.122837,
    images: {
      main: '/images/stores/munjeong/main.jpg',
      exterior: '/images/stores/munjeong/exterior.jpg',
      interior: '/images/stores/munjeong/interior.jpg'
    }
  },
  {
    id: 'sacheon',
    name: '사천점',
    region: '경남',
    city: '사천시',
    address: '경남 사천시 정동면 옥산로 35 1층',
    phone: '',
    hours: '일 정기휴무 / 월~금 10:00-19:00 / 토 10:00-18:00',
    lat: 35.080008,
    lng: 128.086945,
    images: {
      main: '/images/stores/sacheon/main.jpg',
      exterior: '/images/stores/sacheon/exterior.jpg',
      interior: '/images/stores/sacheon/interior.jpg'
    }
  },
  {
    id: 'samcheonpo',
    name: '삼천포점',
    region: '경남',
    city: '사천시',
    address: '경남 사천시 삼상로 98 1층',
    phone: '0507-1410-3362',
    hours: '일 정기휴무 / 월~금 10:30-19:00 / 토 10:30-18:00',
    lat: 34.93746,
    lng: 128.085837,
    images: {
      main: '/images/stores/samcheonpo/main.jpg',
      exterior: '/images/stores/samcheonpo/exterior.jpg',
      interior: '/images/stores/samcheonpo/interior.jpg'
    }
  },
  {
    id: 'sinpung',
    name: '신풍지점',
    region: '서울',
    city: '영등포구',
    address: '서울 영등포구 신풍로 33 1층',
    phone: '02-849-4988',
    hours: '일 정기휴무 / 월~금 10:00-19:00 / 토 10:00-17:00',
    lat: 37.500411,
    lng: 126.909924,
    images: {
      main: '/images/stores/sinpung/main.jpg',
      exterior: '/images/stores/sinpung/exterior.jpg',
      interior: '/images/stores/sinpung/interior.jpg'
    }
  },
  {
    id: 'yangdeok',
    name: '양덕점',
    region: '경남',
    city: '창원시',
    address: '경남 창원시 마산회원구 삼호로 80 메트로 광장상가 128호',
    phone: '0507-1426-2546',
    hours: '일 정기휴무 / 월~금 10:00-20:00 / 토 11:00-19:00',
    lat: 35.225097,
    lng: 128.585336,
    images: {
      main: '/images/stores/yangdeok/main.jpg',
      exterior: '/images/stores/yangdeok/exterior.jpg',
      interior: '/images/stores/yangdeok/interior.jpg'
    }
  },
  {
    id: 'jamwon',
    name: '잠원점',
    region: '서울',
    city: '서초구',
    address: '서울 서초구 잠원로4길 33-2 스타빌딩 1층',
    phone: '0507-1314-5209',
    hours: '일 12:00-18:00 / 월~금 10:00-19:00 / 토 12:00-18:00',
    lat: 37.512879,
    lng: 127.010829,
    images: {
      main: '/images/stores/jamwon/main.jpg',
      exterior: '/images/stores/jamwon/exterior.jpg',
      interior: '/images/stores/jamwon/interior.jpg'
    }
  },
  {
    id: 'cheongdam',
    name: '청담점',
    region: '서울',
    city: '강남구',
    address: '서울 강남구 학동로101길 11 엘프론트 1층 113호',
    phone: '02-546-5000',
    hours: '일 정기휴무 / 월~금 10:00-18:00 / 토 12:00-18:00',
    lat: 37.521396,
    lng: 127.057399,
    images: {
      main: '/images/stores/cheongdam/main.jpg',
      exterior: '/images/stores/cheongdam/exterior.jpg',
      interior: '/images/stores/cheongdam/interior.jpg'
    }
  },
  {
    id: 'tongyeong',
    name: '통영점',
    region: '경남',
    city: '통영시',
    address: '경남 통영시 광도면 죽림4로 18 한국국민금거래소',
    phone: '0507-1378-3867',
    hours: '일 12:00-18:00 / 월~토 10:00-19:00',
    lat: 34.885547,
    lng: 128.416439,
    images: {
      main: '/images/stores/tongyeong/main.jpg',
      exterior: '/images/stores/tongyeong/exterior.jpg',
      interior: '/images/stores/tongyeong/interior.jpg'
    }
  },
  {
    id: 'pyeongtaek-godeok',
    name: '평택고덕지점',
    region: '경기남부',
    city: '평택시',
    address: '경기 평택시 고덕갈평6길 29 삼성메디컬타워 106호',
    phone: '0507-1372-9647',
    hours: '일 12:00-18:00 / 월~토 10:00-19:00',
    lat: 37.057116,
    lng: 127.047417,
    images: {
      main: '/images/stores/pyeongtaek-godeok/main.jpg',
      exterior: '/images/stores/pyeongtaek-godeok/exterior.jpg',
      interior: '/images/stores/pyeongtaek-godeok/interior.jpg'
    }
  }
];

// 이미지 관리 유틸리티 함수들
export const getStoreImage = (storeId, imageType = 'main') => {
  const store = stores.find(s => s.id === storeId);
  return store?.images?.[imageType] || '/images/stores/default.jpg';
};

export const updateStoreImages = (storeId, newImages) => {
  const storeIndex = stores.findIndex(s => s.id === storeId);
  if (storeIndex !== -1) {
    stores[storeIndex].images = { ...stores[storeIndex].images, ...newImages };
  }
};

export const getStoresByImageAvailability = (imageType) => {
  return stores.filter(store => store.images && store.images[imageType]);
};
